import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    TypeEntityTypes,
} from '@pf/shared-common';
import { createMap, forMember, mapFrom, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    EquipmentTypeCreate,
    EquipmentTypeDto,
    EquipmentTypeRead,
    EquipmentTypeSearchParams,
} from '../../entities/equipment-type.dto';
import {
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';
import { withWarehouseSearchFilter } from '../wms-mapping.util';

const symbols = entitySymbols(TypeEntityTypes.WarehouseEquipmentType);

withDefaultEntityMetadata<EquipmentTypeDto>(symbols.dto, {
    category: String,
    code: String,
    customFields: CustomFieldMetadataMap.symbols.dto,
    description: String,
    isScannable: Boolean,
    name: String,
    requiresAuthorization: Boolean,
    resourceAuth: ResourceAuthSymbol,
    warehouse: Object,
});

withDefaultEntityMetadata<EquipmentTypeRead>(symbols.entity, {
    category: String,
    code: String,
    customFields: CustomFieldMetadataMap.symbols.entity,
    description: String,
    isScannable: Boolean,
    name: String,
    requiresAuthorization: Boolean,
    resourceAuth: ResourceAuthSymbol,
    warehouse: Object,
});

withMetadata<EquipmentTypeCreate>(symbols.createBody, {
    category: String,
    code: String,
    description: String,
    isScannable: Boolean,
    name: String,
    requiresAuthorization: Boolean,
    resourceAuth: ResourceAuthSymbol,
    warehouseId: String,
});

withDefaultSearchParamsMetadata<EquipmentTypeSearchParams>(
    symbols.searchParams,
    {
        name: String,
        code: String,
        category: String,
        warehouseId: String,
    }
);

export const EquipmentTypeMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<EquipmentTypeRead, EquipmentTypeDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<EquipmentTypeDto, EquipmentTypeRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<EquipmentTypeDto, EquipmentTypeCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            forMember(
                p => p.warehouseId,
                mapFrom(p => p.warehouse.id)
            )
        );
        createMap<IQueryParams<EquipmentTypeDto>, EquipmentTypeSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('name'),
            withSearchFilter('code'),
            withSearchFilter('category'),
            withWarehouseSearchFilter(),
            ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
